import React from 'react';
import useSkipStepStore from '../../stores/useSkipStepStore';
import { useStepNavigation } from '../../hooks/useStepNavigation';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/dialog';

/**
 * Confirm dialog shown when the user presses Next on a step whose tools have
 * not been applied. Lists the step's tools one by one so the user knows what
 * they are skipping (shared across StepHeader / StepFooter).
 */
export default function SkipStepDialog() {
  const pending = useSkipStepStore((state) => state.pending);
  const { confirmSkip, cancelSkip } = useStepNavigation();
  const toolNames = pending?.toolNames ?? [];

  return (
    <AlertDialog
      open={!!pending}
      onOpenChange={(open) => {
        if (!open) cancelSkip();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Skip this step?</AlertDialogTitle>
          <AlertDialogDescription>
            You haven&apos;t applied any tool on this step. Are you sure you want
            to skip it? You&apos;ll be skipping:
          </AlertDialogDescription>
        </AlertDialogHeader>
        <ul className="my-1 list-disc space-y-1 pl-6 text-sm text-neutral-700">
          {toolNames.map((name) => (
            <li key={name}>{name}</li>
          ))}
        </ul>
        <AlertDialogFooter>
          <AlertDialogCancel>Stay on this step</AlertDialogCancel>
          <AlertDialogAction onClick={confirmSkip}>
            Skip step
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
